import React from 'react';

export type MemberStatTone = 'teal' | 'blue' | 'amber' | 'slate' | 'red';

interface MemberStatCardProps {
  icon: React.ReactNode;
  label: string;
  /** Big primary value. Omit (or pass a node) to show muted placeholder text instead. */
  value?: React.ReactNode;
  /** Optional small tone-coloured delta line under the value. */
  delta?: React.ReactNode;
  /** Tone drives icon-tile colour. */
  tone?: MemberStatTone;
  /** Optional CTA shown when the metric is "empty" — e.g. "Generează cronologie". */
  ctaLabel?: string;
  onCtaClick?: () => void;
  /** Optional sublabel rendered as a smaller muted value (when there's no big number). */
  emptyLabel?: string;
}

const MemberStatCard: React.FC<MemberStatCardProps> = ({
  icon,
  label,
  value,
  delta,
  tone = 'teal',
  ctaLabel,
  onCtaClick,
  emptyLabel,
}) => {
  return (
    <div className="member-stat" role="group" aria-label={label}>
      <div className={`member-stat-icon member-stat-icon-${tone}`} aria-hidden>
        {icon}
      </div>
      <div className="member-stat-body">
        <div className="member-stat-label">{label}</div>
        {value !== undefined ? (
          <div className="member-stat-value">{value}</div>
        ) : (
          <div className="member-stat-value-muted">{emptyLabel || '—'}</div>
        )}
        {delta && <div className="member-stat-delta">{delta}</div>}
        {ctaLabel && onCtaClick && (
          <button type="button" className="member-stat-cta" onClick={onCtaClick}>
            {ctaLabel} →
          </button>
        )}
      </div>
    </div>
  );
};

export default MemberStatCard;
